export default __webpack_public_path__ + "static/media/close-circle.153ed228.svg";